<template>
	<footer class="footer">
		<div class="maxW">
			<div class="i_copyright">{{ info.info_copyright}}1111</div>
		</div>
	</footer>
</template>
<script>
	export default {
		data() {
			return {
				pageFootData: {},
				info: {}
			};
		},
		created() {
			this.getPageFootData();
		},
		computed: {
			getPath: function() {
				return this.$route.path == "/" || this.$route.path == "/home" || this.$route.path == "/home/" ? true : false;
			}
		},
		methods: {
			getPageFootData() {
				let success = res => {
					this.pageFootData = res.data;
					this.info = res.data.info;
					this.$emit("emitInfoPhone", this.info.info_phone);
				};
				this.$ajax({
					url: "api/setting/page_foot",
					method: "get",
					params: {},
					func: {
						success: success
					}
				});
			}
		}
	};
</script>


<style lang="scss">
	.footer {
		background-color: #3a486f;
		background-color: #2C2E3F;
	}

	.i_footerBox {
		padding: 20px 0;
		font-size: 14px;
		color: #ffffff;
		border-bottom: 1px dashed #697798;
	}

	.i_address {
		width: 35.75%;
		border-right: 1px dashed #697798;
	}

	.i_address>ul>li {
		line-height: 19px;
	}

	.i_address>ul>li:nth-of-type(2) {
		padding: 20px 0;
	}

	.i_friendlyLink {
		width: 60%;
	}

	.i_friendlyLink1 {
		text-align: center;
	}

	.i_friendlyLink1>a {
		display: inline-block;
		vertical-align: top;
		color: #ffffff;
		border-right: 1px solid #969696;
		width: 26.38889%;
		line-height: 19px;
	}

	.i_friendlyLink1>a:last-of-type {
		border: 0;
	}

	.i_friendlyLink2 {
		margin-top: 40px;
		text-align: center;
	}

	.i_friendlyLink2>span {
		line-height: 19px;
	}

	.i_friendlyLink2>a {
		display: inline-block;
		vertical-align: top;
		color: #a2b2d5;
		line-height: 19px;
		padding-left: 25px;
	}

	.i_copyright {
		line-height: 16px;
		color: #fff;
		padding: 14px 0;
		text-align: center;
		white-space: pre
	}
</style>
